import * as React from "react";
import { Navigate } from "react-router-dom";

import { useWorkspaceURL } from "../hooks";

export default function LeadsPage() {
  const workspaceURL = useWorkspaceURL();
  return <Navigate to={workspaceURL("conversion-events")} />;
}
